var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8868 3.34998C11.3427 2.42623 12.6599 2.42623 13.1158 3.34998L15.4224 8.02357L20.58 8.77301C21.5994 8.92114 22.0065 10.1739 21.2688 10.8929L17.5367 14.5308L18.4178 19.6676C18.5919 20.6829 17.5262 21.4572 16.6144 20.9778L12.0013 18.5525L7.38821 20.9778C6.47642 21.4572 5.41076 20.6829 5.58489 19.6676L6.46592 14.5308L2.73383 10.8929C1.99618 10.1739 2.40323 8.92114 3.42264 8.77301L8.58026 8.02357L10.8868 3.34998ZM12.0013 3.99686L9.72323 8.61279C9.54219 8.97961 9.19225 9.23386 8.78744 9.29268L3.69346 10.0329L7.3795 13.6259C7.67242 13.9114 7.80609 14.3228 7.73694 14.726L6.86678 19.7994L11.423 17.404C11.785 17.2137 12.2176 17.2137 12.5797 17.404L17.1359 19.7994L16.2657 14.726C16.1966 14.3228 16.3302 13.9114 16.6232 13.6259L20.3092 10.0329L15.2152 9.29268C14.8104 9.23386 14.4605 8.97961 14.2794 8.61279L12.0013 3.99686Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteStar);
export default __webpack_public_path__ + "static/media/WhiteStar.e668eac74b2243aa0d515c5ed5848d9f.svg";
export { ForwardRef as ReactComponent };